module.exports = __webpack_public_path__ + "bb46230f55cc3dd4b18ef490d0edfd0c.svg";